import { httpCreate } from './http';

const http = httpCreate('/srv/game-resources');

export const gameMaterial = {
	getGameMaterial(activityId, gameType) {
		return http.get(`/list/${activityId}?gameType=${gameType}`);
	},
	updateGameMaterial(params) {
		return http.post('', params);
	},
	deleteGameIcom(id) {
		return http.delete(`/${id}`);
	},
};
